<app-toaster class="toaster" [config]="toasterService.toaster"></app-toaster>
<div class="center">
  <form [formGroup]="limitForm" class="flex-col width-800" (ngSubmit)="createLimit()" (wheel)="stopAmountScroll($event)">
    <h2 class="center margin-y-10">Create Limit</h2>

    <div class="info-banner margin-y-10">
      <mat-icon class="info-icon">info</mat-icon>
      <span>Enter any of the four limits. Each value is submitted separately. City is required. Saved limits show up in the list right away; when maker-checker is enabled, limits stay pending until a checker approves them (see Limit Approvals).</span>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">City: *</label>
      <ng-select
        formControlName="city"
        name="city"
        placeholder="Select city"
        class="flex-grow font-16 margin-l-10"
        [clearable]="false">
        <ng-option *ngFor="let item of cities" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Shift:</label>
      <ng-select
        formControlName="shift"
        name="shift"
        placeholder="Select shift"
        class="flex-grow font-16 margin-l-10"
        [disabled]="!limitForm.get('city').value">
        <ng-option *ngFor="let shift of shifts" [value]="shift">{{shift}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Service:</label>
      <ng-select
        formControlName="service"
        name="service"
        placeholder="Select service"
        class="flex-grow font-16 margin-l-10"
        [disabled]="!limitForm.get('city').value">
        <ng-option *ngFor="let item of services" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10 field-row" *ngFor="let field of amountFields">
      <label class="width-50 font-16 bold">{{ field.label }}:</label>
      <div class="flex-grow margin-l-10 field-control">
        <input
          [formControlName]="field.key"
          type="number"
          [name]="field.key"
          [placeholder]="field.placeholder"
          step="1"
          class="limit-input"
          [class.limit-input-error]="fieldError(field.key)"
          (keydown)="blockNonIntegerKey($event)"
          (paste)="blockNonIntegerPaste($event)" />
        <p class="field-error" *ngIf="fieldError(field.key)">{{ fieldError(field.key) }}</p>
        <p class="field-hint" *ngIf="!fieldError(field.key)">Must be a negative integer (e.g. -30).</p>
      </div>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold">Priority: *</label>
      <input
        formControlName="priority"
        type="number"
        name="priority"
        min="1"
        placeholder="0"
        class="flex-grow font-16 margin-l-10 limit-input" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-16 bold"></label>
      <mat-checkbox formControlName="active" class="flex-grow font-16 margin-l-10" color="primary">
        Active
      </mat-checkbox>
    </div>

    <div class="flex-row margin-y-20 justify-end">
      <button type="submit" class="btn btn-primary" [disabled]="submitting || hasAmountError">Submit</button>
    </div>
  </form>
</div>
<app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
